import React from 'react'
import { getColorInsuranceLogo } from '@/utils/getColorInsuranceLogo'
export const InsuranceChip = ({ slug }: { slug: string }) => {
  const logoComponent = getColorInsuranceLogo(slug)

  if (!logoComponent) {
    return null
  }

  return (
    <div className="inline-flex h-12 flex-col justify-start gap-2 rounded-[100px] bg-white/60 px-4 py-3 md:h-[52px]">
      <div>
        <img
          src={logoComponent}
          className="h-6 md:h-7"
        />
      </div>
    </div>
  )
}
